<!--
 * @Author       : aa
 * @Date         : 2020-06-15 12:05:17
 * @Description  : 题号列表
 * @FilePath     : \vue-gaokao-ebook\src\views\my_personal\evaluation_record\card.vue
--> 
<template>
  <div class="question_card">
    <div class="card">
      <div class="nav">题号索引</div>
      <div class="comparison">
        <div>
          <div class="yizuoda"></div>
          <span>已作答</span>
        </div>
        <div>
          <div class="no_pigai"></div>
          <span>未作答</span>
        </div>
      </div>
      <div class="number_list">
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :class="[
            completionClass(qs.status),
            { active: index == activeIindex1 },
          ]"
          :id="'anchor' + qs.id"
          @click="gotoTarget(qs.id, index, 1)"
        >
          {{ qs.originalName }}
        </div>
      </div>
    </div>

    <div class="card">
      <div class="nav">批改索引</div>
      <div class="comparison">
        <div>
          <div class="already"></div>
          <span>正确</span>
        </div>
        <div>
          <div class="not_yet"></div>
          <span>错误</span>
        </div>
        <div>
          <div class="no_pigai"></div>
          <span>未批改</span>
        </div>
      </div>
      <div class="number_list">
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :class="[
            correctingClass(qs.correct, qs.completionStatus),
            { active: index == activeIindex2 },
          ]"
          :id="'anchor' + qs.id"
          @click="gotoTarget(qs.id, index, 2)"
        >
          {{ qs.order }}
        </div>
      </div>
    </div>
    <div class="card" style="padding-bottom: 80px">
      <div class="nav">正误索引</div>
      <div class="comparison">
        <div>
          <div class="already"></div>
          <span>正确</span>
        </div>
        <div>
          <div class="not_yet"></div>
          <span>错误</span>
        </div>
      </div>
      <div class="number_list">
        <div
          v-for="(qs, index) in questionStatus"
          :key="index"
          :class="[
            correctClass(qs.correct),
            { active: index == activeIindex3 },
          ]"
          :id="'anchor' + qs.id"
          @click="gotoTarget(qs.id, index, 3)"
        >
          {{ qs.order }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIindex1: -1,
      activeIindex2: -1,
      activeIindex3: -1
    };
  },
  props: {
    questionStatus: Array,
    questionSubmitInfo: Object,
    answerCount: Number
  },
  computed: {
    completionClass() {
      return completionStatus => {
        if (completionStatus) {
          return "yizuoda";
        } else {
          return "no_pigai";
        }
      };
    },
    correctingClass() {
      return (correct, completionStatus) => {
        if (completionStatus) {
          if (correct) {
            return "already";
          } else {
            return "not_yet";
          }
        } else {
          return "no_pigai";
        }
      };
    },
    correctClass() {
      return correct => {
        if (correct) {
          return "already";
        } else {
          return "not_yet";
        }
      };
    }
  },
  components: {},
  mounted() {
    console.log(this.props.questionStatus);
  },
  methods: {
    gotoTarget(o, ind, type) {
      let s = "#anchor" + o;
      let qs = document.querySelector(s);
      if (qs == undefined) return;
      document.querySelector(s).scrollIntoView(true);
      this.activeIindex = ind;
      if (type == 1) {
        this.activeIindex1 = ind;
      } else if (type == 2) {
        this.activeIindex2 = ind;
      } else if (type == 3) {
        this.activeIindex3 = ind;
      }
      const gap = document.documentElement.scrollTop || document.body.scrollTop;
      scrollTo(0, gap - 175);
    }
  }
};
</script>
<style lang="stylus" scoped>
.question_card {
  width: 300px;
  position: fixed;
  height: auto;
  overflow-y: auto;
  padding-bottom: 180px;
  margin-left: 30px;

  .card {
    width: 298px;
    overflow: hidden;
    height: 500px;
    border: 1px #5c307d solid;
    margin-top: 30px;

    .nav {
      width: 300px;
      height: 38px;
      background-color: #5c307d;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
    }

    .comparison {
      width: 300px;
      height: 45px;
      margin-top: 25px;
      display: flex;
      justify-content: space-around;

      .already {
        width: 20px;
        height: 20px;
        background-color: #a7f1c0;
        border: 1px #2fb700 solid;
        margin-top: 3px;
        float: left;
      }

      .not_yet {
        width: 20px;
        height: 20px;
        background-color: #ffbfbf;
        border: 1px #ff8181 solid;
        float: left;
        margin-top: 3px;
      }

      .no_pigai {
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        border: 1px #5c307d solid;
        float: left;
        margin-top: 3px;
      }

      .yizuoda {
        width: 20px;
        height: 20px;
        background-color: #f0f0f0;
        border: 1px #d5d5d5 solid;
        float: left;
        margin-top: 3px;
        color: #bcbcbc;
      }

      span {
        font-size: 19px;
        color: #5c307d;
        margin-left: 10px;
      }
    }

    .number_list {
      width: 300px;
      height: 390px;
      overflow-x: hidden;

      .already {
        width: 38px;
        height: 38px;
        border: 1px #2fb700 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #a7f1c0;
        color: #bebebe;
        cursor: pointer;
      }

      .not_yet {
        width: 38px;
        height: 38px;
        border: 1px #ff8181 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffbfbf;
        cursor: pointer;
      }

      .no_pigai {
        width: 38px;
        height: 38px;
        border: 1px #5c307d solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        background-color: #ffffff;
        cursor: pointer;
      }

      .yizuoda {
        width: 38px;
        height: 38px;
        border: 1px #d5d5d5 solid;
        float: left;
        margin-left: 15px;
        margin-top: 15px;
        text-align: center;
        line-height: 38px;
        font-size: 17px;
        background-color: #f0f0f0;
        color: #bcbcbc;
        cursor: pointer;
      }

      .active {
        border: 1px solid #5c307d;
        background-color: #f1dfff;
      }
    }
  }

  .btns {
    width: 330px;
    height: 130px;
    margin-top: 45px;
    position: relative;
    float: left;

    .btn {
      width: 230px;
      height: 50px;
      margin-left: 35px;
      margin-top: 30px;
      background-color: #5c307d;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
    }
  }
}

/* webkit内核 */
.question_card::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/* o内核 */
.question_card .-o-scrollbar {
  -moz-appearance: none !important;
  background: rgba(0, 255, 0, 0) !important;
}

/* IE10,IE11,IE12 */
.question_card {
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
  overflow: auto;
}
</style>
